import { Box } from '@mui/material';

import { WheelSvg } from 'assets/svg/service-icons';
import { bgColors, glowColor, redColors } from 'theme/colors';

type TirePanelProps = {
  minHeight?: number | string;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  glowPosition?: string;
};

const TirePanel: React.FC<TirePanelProps> = ({ minHeight = 200, icon: Icon = WheelSvg, glowPosition = '30% 20%' }: TirePanelProps) => {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        minHeight,
        py: 4,
        bgcolor: bgColors.light,
        backgroundImage: `radial-gradient(ellipse 90% 70% at ${glowPosition}, ${glowColor}, transparent 65%)`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '52%',
          maxWidth: 190,
          filter: `drop-shadow(0 0 26px ${redColors.dark}77)`,
          opacity: 0.9,
        }}
      >
        <Icon fill={redColors.light} />
      </Box>
    </Box>
  );
};

export default TirePanel;
